import cx from 'classnames'
import { Icons, Icon } from './icon'

interface DisclaimerProps {
  variant?: 'default' | 'warning'
  text: string
}

const Disclaimer = ({ text, variant = 'default' }: DisclaimerProps) => {
  const role = variant === 'warning' ? 'alert' : 'status'

  return (
    <div
      className={cx('disclaimer', variant)}
      role={role}
      aria-live={variant === 'warning' ? 'assertive' : 'polite'}
    >
      <Icon
        className="disclaimer-icon"
        size={14}
        name={variant === 'warning' ? Icons.Warning : Icons.Info}
      />
      <p className="disclaimer-text">{text}</p>
    </div>
  )
}

export default Disclaimer
